import { Grid, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles({
    name: {
        fontSize: '1rem',
    },
    propertyName: {
        fontWeight: 'bold',
    },
});

const ShapesTooltip = ({ level , properties }) => {
    const classes = useStyles();
    let levelAlarm
    if (level !== 0) {
        levelAlarm='En Alerta'
    }else{
        levelAlarm='Apagado'
    }

    
    

    return (
        <Grid container>
            <Grid item xs={12}>
                <span className={classes.propertyName}>Nivel: </span>
                {levelAlarm}
            </Grid>
            <Grid item xs={12}>
                <span className={classes.propertyName}>Propiedades: </span>
                {properties}
            </Grid>
        </Grid>
    );
};

ShapesTooltip.propTypes = {
    level: PropTypes.number.isRequired,
    properties: PropTypes.string.isRequired,
};

export default ShapesTooltip;
